import { select } from 'redux-saga/effects';
import ApiService from '../services/ApiService';
import { selectApiToken, selectTenantId } from './selectors';

export function* getApiService() {
  const accessToken = yield select(selectApiToken);
  const tenantId = yield select(selectTenantId);
  return new ApiService({ accessToken, tenantId });
}
